module.exports = __webpack_public_path__ + "static/media/masthead-south-western-times.a241c27c.png";